import React from "react";
import styled from "styled-components";

const CardReview = (props) => {
  return (
    <MainWrap>
      <Name> {props.name}</Name>
      <Caption>{props.caption}</Caption>
      <Review>{props.rev}</Review>
    </MainWrap>
  );
};

export default CardReview;

const MainWrap = styled.div`
  display: flex;
  flex-direction: column;
  ${"" /* justify-content: center; */}
  width: 33%;
  background: rgba(0, 0, 0, 0.8);
  padding: 20px;
  margin: 20px 50px;
  font-family: "Nunito Sans", sans-serif;

  @media (max-width: 1000px) {
    width: 90%;
    margin: 20px 0;
    padding: 0 10px;
  }
`;

const Name = styled.div`
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
  font-style: italic;

  @media (max-width: 767px) {
    font-size: 18px;
  }
`;

const Caption = styled.div`
  padding: 10px 0;
  font-size: 20px;
  color: white;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.8);

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const Review = styled.div`
  padding: 30px 0;
  font-family: "Exo", sans-serif;
  line-height: 130%;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
